import React, { useEffect, useRef, useState } from "react";
import { Gift, Share2, Users, IndianRupee, Sparkles } from "lucide-react";
import { resolveMediaUrl } from "@/lib/api";

/**
 * Refer & Earn visual: the NAVI CARE logo at the centre, ripples going out, and
 * share -> friends -> gift -> reward icons orbiting it. Only transform/opacity are animated,
 * and animation runs only while the card is on screen (IntersectionObserver).
 */
const ORBIT = [
  { Icon: Share2, angle: 0, label: "Share" },
  { Icon: Users, angle: 90, label: "Friends join" },
  { Icon: Gift, angle: 180, label: "Gift" },
  { Icon: IndianRupee, angle: 270, label: "Earn" },
];

export default function ReferAnimation({ logoUrl }) {
  const ref = useRef(null);
  const [on, setOn] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el || !("IntersectionObserver" in window)) { setOn(true); return undefined; }
    const io = new IntersectionObserver(([e]) => setOn(e.isIntersecting), { threshold: 0.2 });
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <div ref={ref} className={`navi-ref-visual ${on ? "is-running" : ""}`} aria-hidden="true" data-testid="refer-animation">
      <span className="navi-ref-ripple" />
      <span className="navi-ref-ripple navi-ref-ripple-2" />
      <span className="navi-ref-ring" />
      <div className="navi-ref-orbit">
        {ORBIT.map(({ Icon, angle, label }) => (
          <span key={label} className="navi-ref-item" style={{ "--a": `${angle}deg` }}>
            <span className="navi-ref-item-in"><Icon className="w-4 h-4" /></span>
          </span>
        ))}
      </div>
      <div className="navi-ref-core">
        {logoUrl ? <img src={resolveMediaUrl(logoUrl)} alt="" loading="lazy" decoding="async" width="56" height="56" /> : <Sparkles className="w-7 h-7" />}
      </div>
    </div>
  );
}
